<div class="loader">
  <div class="loader__spinner">
    <mat-progress-spinner
      mode="indeterminate"
      [strokeWidth]="strokeWidth"
    ></mat-progress-spinner>
    <div>Loading...</div>
  </div>
</div>
